import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';
class PagerUtils {
    static GetFilterData(): any {
        const dataProviders = $('[pager-trigger]');
        const dataArray = {};

        for (let i = 0; i <= dataProviders.length; i++) {
            const propName = $(dataProviders[i]).data('propertyname');
            const nodeName = $(dataProviders[i]).prop('nodeName');

            let propValue = '';
            const className = 'selected_value_' + propName;

            if (
                nodeName != 'SELECT' &&
                $(dataProviders[i]).hasClass(className)
            ) {
                propValue = $(dataProviders[i]).data('propertyvalue');
            } else {
                propValue = $(dataProviders[i]).val();
            }

            if (propName && propValue) {
                const data = {};
                data[propName] = propValue;
                $.extend(dataArray, data);
            }
        }

        return dataArray;
    }

    static GetCurrentPage(element: any): number {
        const maxPage = $(element).data('maxpage');
        const minPage = $(element).data('minpage');
        let requestedPage = $(element).val() - 1;

        if (requestedPage > maxPage) requestedPage = maxPage;
        if (requestedPage < minPage) requestedPage = minPage;
        return requestedPage;
    }
}
/**
 * PagerTrigger - устанавливает на элемент разметки с аттрибутом pager-trigger смену фильтров через Ajax.postJson
 * Если элемент с тэгом А то по клику, если элемент Select то по изменению
 * Предназначен для определения дополнительных фильтров
 * pager-trigger-after выполняется после фильтрации
 * pager-trigger-before выполняется до фильтрации
 * pager-trigger-minlength задает минимальную длинну запроса для отправки на сервер
 * для input используется keyup и таймер
 */
export class PagerTriggerBehaviour extends BaseEmptyPrefixControlBehaviour {
    constructor() {
        super('pager-trigger');
    }

    protected installBehaviour(element: HTMLElement): void {
        const nodeName = $(element).prop('nodeName');
        if (nodeName == 'INPUT') {
            let searchSendTimeoutHandler;
            let lastQuery = $(element).val();
            const minLength =
                parseInt($(element).attr(this.tag + '-minlength')) || 1;
            $(element).on('keyup', () => {
                const query = $(element).val();

                if (query === lastQuery && query.length > 0) return false;

                if (query.length < minLength && query.length > 0) return false;
                lastQuery = query.trim();
                clearTimeout(searchSendTimeoutHandler);
                searchSendTimeoutHandler = setTimeout(() => {
                    this.handleFilterChange(element);
                }, 500);
            });
        } else {
            let eventName = '';
            switch (nodeName) {
                case 'A':
                case 'DIV': {
                    eventName = 'click';
                    break;
                }
                case 'SELECT': {
                    eventName = 'change';
                    break;
                }
            }
            $(element).on(eventName, () => {
                this.handleFilterChange(element);
            });
        }
    }

    private handleFilterChange(element: any) {
        this.before(element);

        if ($(element).prop('nodeName') == 'A') {
            const propName = $(element).data('propertyname');
            const className = 'selected_value_' + propName;
            const current = $('.' + className);
            current.each((index, value) => {
                $(value).removeClass(className);
            });
            $(element).addClass(className);
        }

        let data = PagerUtils.GetFilterData();
        data = Utils.getObjectByAttributes('data', element, null, data);
        data.page = $.extend({}, { number: 0 }, data.page);
        const url = $(element).attr('filterUrl');

        const uiBlock = UiBlock.getUiBlockDescriptor(
            element,
            UiBlock.getDefaultSpinnerBlock(element)
        );
        Ajax.postJson(url, {
            data: data,
            success: () => {
                this.after(element);
            },
            uiBlock: uiBlock,
        });
    }

    private before(element: any) {
        const before = $(element).attr(this.tag + '-before');
        this.call(before, element);
    }

    private after(element: any) {
        const after = $(element).attr(this.tag + '-after');
        this.call(after, element);
    }

    private call(func: string, element: any): void {
        if (func != null) {
            if (func.lastIndexOf(';') !== func.length - 1) {
                Utils.runFunctionByName(func, null, element);
            } else {
                Function(func).apply(element);
            }
        }
    }
}

/**
 * Pager - устанавливает на элемент разметки с аттрибутом pager отправку Ajax.postJson по клику на элементе,
 * если он не имеет класса disabled
 */
export class PagerBehaviour extends BaseEmptyPrefixControlBehaviour {
    constructor() {
        super('pager');
    }

    protected installBehaviour(element: any): void {
        const pager = $(element);
        if (!pager.hasClass('disabled')) {
            const pagerData: any = Utils.getObjectByAttributes(
                'page',
                element,
                null,
                { hasPager: true }
            );
            if (pagerData.hasPager) {
                if (pager.is('input')) {
                    //
                    pager.on('change', () => {
                        pagerData.number = PagerUtils.GetCurrentPage(element);

                        this.sendPageRequest(element, pagerData);
                    });
                } else {
                    pager.on('click', () => {
                        this.sendPageRequest(element, pagerData);
                    });
                }
            }
        }
    }

    private sendPageRequest(element: any, pagerData: any) {
        let data = pagerData.data;
        if (data) {
            data = JSON.parse(data);
        }
        data = data || {};
        const additionalData = PagerUtils.GetFilterData();
        if (additionalData) {
            data = $.extend(data, additionalData);
        }
        data = Utils.getObjectByAttributes('data', element, null, data);
        data.page = {
            number: pagerData.number,
            size: pagerData.size,
        };
        const uiBlock = UiBlock.getUiBlockDescriptor(
            element,
            UiBlock.getDefaultSpinnerBlock(element)
        );
        Ajax.postJson(pagerData.url, { data: data, uiBlock: uiBlock });
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.PagerBehaviour = PagerBehaviour;
window.Behaviours.PagerTriggerBehaviour = PagerTriggerBehaviour;